import React from 'react';

import CommandActions from '../../actions/CommandActions';
import CommonUtil from '../../utils/CommonUtil';


export default class GongqiSelectRecordsHeaderCell extends React.Component
{
	constructor(props) {
		super(props);
	}

	checkChangeHandler(e)
	{
		CommandActions.selectAllRecords(e.currentTarget.checked,this.props.groupAlias,this.props.moduleInstanceId);
	}

	componentDidMount()
	{
		
	}


	render()
	{
		let columnName = this.props.column.xmlName;	
		let _nameid = "gridckbox"+columnName+CommonUtil.guid();
		return(
			<div className="react-grid-checkbox-container checkbox-align">
		        <input className="react-grid-checkbox" type="checkbox" name={_nameid} id={_nameid} onChange={this.checkChangeHandler.bind(this)} />
		        <label htmlFor={_nameid} className="react-grid-checkbox-label"></label>
		    </div>
		);
		
	}
}



// WEBPACK FOOTER //
// ./src/formItem/renders/GongqiSelectRecordsHeaderCell.js